import { nameValueArrayFromObject, objectFlip } from './utils.js';
export const enumToCode = {
    AMERICA_ADAK: 'America/Adak',
    AMERICA_ANCHORAGE: 'America/Anchorage',
    AMERICA_BOISE: 'America/Boise',
    AMERICA_CHICAGO: 'America/Chicago',
    AMERICA_DENVER: 'America/Denver',
    AMERICA_DETROIT: 'America/Detroit',
    AMERICA_INDIANA_INDIANAPOLIS: 'America/Indiana/Indianapolis',
    AMERICA_INDIANA_KNOX: 'America/Indiana/Knox',
    AMERICA_INDIANA_MARENGO: 'America/Indiana/Marengo',
    AMERICA_INDIANA_PETERSBURG: 'America/Indiana/Petersburg',
    AMERICA_INDIANA_TELL_CITY: 'America/Indiana/Tell_City',
    AMERICA_INDIANA_VEVAY: 'America/Indiana/Vevay',
    AMERICA_INDIANA_VINCENNES: 'America/Indiana/Vincennes',
    AMERICA_INDIANA_WINAMAC: 'America/Indiana/Winamac',
    AMERICA_JUNEAU: 'America/Juneau',
    AMERICA_KENTUCKY_LOUISVILLE: 'America/Kentucky/Louisville',
    AMERICA_KENTUCKY_MONTICELLO: 'America/Kentucky/Monticello',
    AMERICA_LOS_ANGELES: 'America/Los_Angeles',
    AMERICA_MENOMINEE: 'America/Menominee',
    AMERICA_METLAKATLA: 'America/Metlakatla',
    AMERICA_NEW_YORK: 'America/New_York',
    AMERICA_NOME: 'America/Nome',
    AMERICA_NORTH_DAKOTA_BEULAH: 'America/North_Dakota/Beulah',
    AMERICA_NORTH_DAKOTA_CENTER: 'America/North_Dakota/Center',
    AMERICA_NORTH_DAKOTA_NEW_SALEM: 'America/North_Dakota/New_Salem',
    AMERICA_PHOENIX: 'America/Phoenix',
    AMERICA_SITKA: 'America/Sitka',
    AMERICA_YAKUTAT: 'America/Yakutat',
    PACIFIC_HONOLULU: 'Pacific/Honolulu',
    UTC: 'UTC',
};
export const codeToEnum = objectFlip(enumToCode);
export const timezones = nameValueArrayFromObject(enumToCode);
//# sourceMappingURL=timezones.js.map